import React from "react";
import { useI18n } from "../lib/i18n";

const COLORS = {
  new: "bg-slate-100 text-slate-700 border-slate-200",
  in_review: "bg-amber-100 text-amber-800 border-amber-200",
  selected: "bg-indigo-100 text-indigo-800 border-indigo-200",
  interview: "bg-sky-100 text-sky-800 border-sky-200",
  not_selected: "bg-rose-100 text-rose-700 border-rose-200",
  hired: "bg-emerald-100 text-emerald-800 border-emerald-200",
  not_fit: "bg-slate-800 text-slate-100 border-slate-700",
};

export default function StatusBadge({ status }) {
  const { t } = useI18n();
  const cls = COLORS[status] || COLORS.new;
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold ${cls}`}>
      {t(`status.${status}`)}
    </span>
  );
}

export const STATUS_LIST = ["new", "in_review", "selected", "interview", "not_selected", "hired", "not_fit"];
